import { createRoot } from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './app.css';
import App from './components/App';
import Login from './components/Login';

const container = document.getElementById('root');
const root = createRoot(container);
const Root = window.location.pathname === '/login' ? Login : App;
root.render(<Root />);
